module.exports = __webpack_public_path__ + "img/photo.fdc6e3c8.svg";